import { Icon } from '@chakra-ui/icon';
const RightPagination = props => <Icon viewBox="0 0 6 10" {...props} data-sentry-element="Icon" data-sentry-component="RightPagination" data-sentry-source-file="RightPagination.tsx">
    <path d="M0 10V0L6 5L0 10Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="RightPagination.tsx" />
  </Icon>;
RightPagination.displayName = 'RightPaginationIcon';
export default RightPagination;